import React from "react";
import styled from "styled-components";
import { Button, InputField } from "../../../v2/design-system";
import { theme } from "../../../v2/design-system/theme";

const FilterForm = styled.form`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.spacing.lg};
  flex-wrap: wrap;
`;

const FilterComponent = ({
  filterFields,
  onFilterChange,
  showButton = true,
  buttonText = "Search",
  onFilterSubmit,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onFilterSubmit?.(e);
  };

  return (
    <FilterForm onSubmit={handleSubmit}>
      {filterFields.map((field, index) => (
        <InputField
          key={field.name ?? index}
          name={field.name}
          type={field.type || "text"}
          label={field.label || field.placeholder}
          placeholder={field.placeholder}
          value={field.value ?? ""}
          onChange={(val) => onFilterChange(val, field.name)}
          maxLength={field.maxLength != null ? Number(field.maxLength) : undefined}
          disabled={Boolean(field.disabled)}
        />
      ))}
      {showButton && (
        <Button type="submit" variant="primary" size="sm">
          {buttonText}
        </Button>
      )}
    </FilterForm>
  );
};

export default FilterComponent;
